var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMimarsinan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.8,17.3c-2.9-.8-6.2,0-9.3-.7-2.1-.5-3.5.2-4.3,2.1-1.4,3-3.5,5.7-4.3,9.1-.9,3.8-5.3,4.5-7.8,1.6-1.1-1.3-2.3-2.5-3.2-3.9-1.4-2.1-4.5-3.6-3.7-6.6,1-4,2.6-8.1,6.5-10.1,3.1-1.6,6.7-1,10.2-.5,1.1.2,1.6,2.1,3,1.3,1.8-1.1,3.9-1.7,5.3-3.4.7-.9.9-2.4,2.3-2.4,1.7,0,3.4.9,5.2.8.6,0,.8.9.8,1.5,0,3,.8,5.8,1.5,8.7.4,1.6-.1,2.5-2,2.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMimarsinan);
export default __webpack_public_path__ + "static/media/mimarsinan.4562347bb7a768c4236b0ee0a06edc8a.svg";
export { ForwardRef as ReactComponent };